import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-w.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsWConstants } from "./create-application-details-w.constants";
import { CompareDatesUtil } from "../../../../../shared/utils/date-field-validator.utils";
import { take, takeUntil } from "rxjs/operators";
import { AlertType } from "../../../../../shared/models/alert";
import { WayleaveService } from "../../../../../shared/services/modules/wayleave.service";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { DatePipe } from "@angular/common";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
let CreateApplicationDetailsWComponent = class CreateApplicationDetailsWComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    datePipe;
    wayleaveService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsWConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    verificationMessage = CreateApplicationDetailsWConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    verifyLabel = CreateApplicationDetailsWConstants.VERIFY_LABEL;
    detailsFormFormGroupName = CreateApplicationDetailsWConstants.DETAILS_FORM_GROUP;
    locationFormFormGroupName = CreateApplicationDetailsWConstants.LOCATION_FORM_GROUP_NAME;
    applicantFormGroupName = CreateApplicationDetailsWConstants.APPLICANT_FORM_GROUP_NAME;
    professionalBodiesFormGroupName = CreateApplicationDetailsWConstants.PROFESSIONAL_BODIES_FORM_GROUP_NAME;
    noteFormFormGroupName = CreateApplicationDetailsWConstants.NOTE_FORM_GROUP_NAME;
    notesFormFormArrayName = CreateApplicationDetailsWConstants.NOTE_FORM_ARRAY_NAME;
    applicantFormControlName = CreateApplicationDetailsWConstants.APPLICANT_FORM_CONTROL_NAME;
    applicantAgentFormControlName = CreateApplicationDetailsWConstants.APPLICANT_AGENT_FORM_CONTROL_NAME;
    implementingAgentFormControlName = CreateApplicationDetailsWConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationDetailsWConstants.ENGINEER_FORM_CONTROL_NAME;
    responsibleContractorFormControlName = CreateApplicationDetailsWConstants.RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME;
    markImplementingAgentAsNotApplicableFormControlName = CreateApplicationDetailsWConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markEngineerAsNotApplicableFormControlName = CreateApplicationDetailsWConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markContractorAsNotApplicableFormControlName = CreateApplicationDetailsWConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    descriptionFormControlName = CreateApplicationDetailsWConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsWConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = CreateApplicationDetailsWConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = CreateApplicationDetailsWConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = CreateApplicationDetailsWConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = CreateApplicationDetailsWConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = CreateApplicationDetailsWConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodFormControlName = CreateApplicationDetailsWConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    servicesFormControlName = CreateApplicationDetailsWConstants.SERVICES_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = CreateApplicationDetailsWConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = CreateApplicationDetailsWConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = CreateApplicationDetailsWConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = CreateApplicationDetailsWConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    constructionPeriodUnitsFormControlName = CreateApplicationDetailsWConstants.CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME;
    electricalServicesFormControlName = CreateApplicationDetailsWConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    actualStartDateFormControlName = CreateApplicationDetailsWConstants.ACTUAL_START_DATE_FORM_CONTROL_NAME;
    actualEndDateFormControlName = CreateApplicationDetailsWConstants.ACTUAL_END_DATE_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationDetailsWConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationDetailsWConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsWConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsWConstants.APPLICATION_TYPE_LABEL;
    clientReferenceNumberLabel = CreateApplicationDetailsWConstants.CLIENT_REFERENCE_NUMBER_LABEL;
    applicantTelecommunicationLicenseNumberLabel = CreateApplicationDetailsWConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL;
    scopeOfWorkFormLabel = CreateApplicationDetailsWConstants.SCOPE_OF_WORK_LABEL;
    estimatedConstructionCostLabel = CreateApplicationDetailsWConstants.ESTIMATED_CONSTRUCTION_COST_LABEL;
    applicationFeeLabel = CreateApplicationDetailsWConstants.APPLICATION_FEE_LABEL;
    constructionPeriodLabel = CreateApplicationDetailsWConstants.CONSTRUCTION_PERIOD_LABEL;
    proposedStartDateLabel = CreateApplicationDetailsWConstants.PROPOSED_START_DATE_LABEL;
    proposedEndDateLabel = CreateApplicationDetailsWConstants.PROPOSED_END_DATE_LABEL;
    laneClosureIsRequiredLabel = CreateApplicationDetailsWConstants.LANE_CLOSURE_IS_REQUIRED_LABEL;
    laneClosureExtentLabel = CreateApplicationDetailsWConstants.LANE_CLOSURE_EXTENT_LABEL;
    constructionPeriodUnitsLabel = CreateApplicationDetailsWConstants.CONSTRUCTION_PERIOD_UNITS_LABEL;
    servicesLabel = CreateApplicationDetailsWConstants.SERVICES_LABEL;
    electricalServicesLabel = CreateApplicationDetailsWConstants.ELECTRICAL_SERVICES_LABEL;
    previousReferenceNumberLabel = CreateApplicationDetailsWConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationDetailsWConstants.IS_RESUBMISSION_LABEL;
    applicationTypes = [];
    zones = [];
    isResubmissionOptions = [
        { code: SharedConstants.YES_NO_ENUM.Yes, value: SharedConstants.YES_NO_ENUM.Yes },
        { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }
    ];
    yesNoOptions = [];
    laneClosureExtentOptions = [];
    electricalServicesOptions = [];
    constructionPeriodUnitsOptions = [
        { code: "Days", value: "Days" },
        { code: "Months", value: "Months" },
        { code: "Weeks", value: "Weeks" },
        { code: "Years", value: "Years" }
    ];
    servicesOptions = [];
    applicationTypeOptions = [];
    supportResubmissions = false;
    showVerifyApplicationOptions = false;
    isVerified = false;
    showApplicationDetailsFields = true;
    getTrueCentroidSubscription;
    // Please do not rename variables below
    showscopeOfWork = true;
    showclientReferenceNumber = true;
    showapplicantTelecommunicationLicenseNumber = true;
    showapplicationFee = true;
    showestimatedConstructionCost = true;
    showproposedStartDate = true;
    showproposedEndDate = true;
    showlaneClosureIsRequired = true;
    showlaneClosureExtent = true;
    showconstructionPeriodUnits = true;
    showservices = true;
    showconstructionPeriod = true;
    showelectricalServices = true;
    constructor(createApplicationService, aflaModuleStrategyService, appController, datePipe, wayleaveService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.datePipe = datePipe;
        this.wayleaveService = wayleaveService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        if (this.appController.moduleSimulateMode) {
            this.onSimulateMode();
        }
        else {
            this.checkLookups();
            this.checkIsResubmission();
            this.getMetadata();
        }
        this.repopulateDetailsPage();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        if (stepMeta && stepMeta.hasOwnProperty("applicationDetailsFields")) {
            const detailsFieldsOptions = stepMeta.applicationDetailsFields;
            this.setRequiredFieldsFromStepMeta(detailsFieldsOptions);
            this.showOrHideApplicationDetailsFields(detailsFieldsOptions);
            this.detailsForm.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    verifyProposedDates(formControlName) {
        // checks if the startDate is >= endDate
        CompareDatesUtil.verifyProposedDates(this.detailsForm, this.proposedStartDateFormControlName, this.proposedEndDateFormControlName, formControlName, this.appController);
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'LaneClosureExtent' or name eq 'ElectricalServices' or name eq 'ApplicationType' or name eq 'Services')`,
        };
        this.createApplicationService.getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const laneClosureExtents = [];
        const electricalServices = [];
        const services = [];
        const applicationType = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "LaneClosureExtent") {
                    laneClosureExtents.push(JSON.parse(item.content));
                }
                if (item.name === "ElectricalServices") {
                    electricalServices.push(JSON.parse(item.content));
                }
                if (item.name === "Services") {
                    services.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    applicationType.push(JSON.parse(item.content));
                }
            });
        }
        laneClosureExtents.sort((a, b) => a.value.localeCompare(b.value));
        electricalServices.sort((a, b) => a.value.localeCompare(b.value));
        applicationType.sort((a, b) => a.value.localeCompare(b.value));
        services.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        this.aflaModuleStrategyService.lookups.set("laneClosureExtents", laneClosureExtents);
        this.laneClosureExtentOptions = laneClosureExtents;
        this.aflaModuleStrategyService.lookups.set("electricalServices", electricalServices);
        this.electricalServicesOptions = electricalServices;
        this.aflaModuleStrategyService.lookups.set("services", services);
        this.servicesOptions = services;
        this.aflaModuleStrategyService.lookups.set("applicationType", applicationType);
        this.applicationTypeOptions = applicationType;
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).reset();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
            this.showVerifyApplicationOptions = true;
            this.showApplicationDetailsFields = false;
        }
        else {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
            this.showVerifyApplicationOptions = false;
            this.isVerified = false;
            this.showApplicationDetailsFields = true;
            this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).get(this.notesFormFormArrayName).clear();
            this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).reset();
        }
        this.detailsForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    resetVerification() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.isVerified = false;
        this.showApplicationDetailsFields = false;
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        this.detailsForm.get(this.descriptionFormControlName).reset();
        this.detailsForm.get(this.applicationTypeFormControlName).reset();
        this.detailsForm.get(this.constructionPeriodFormControlName).reset();
        this.detailsForm.get(this.applicationTypeFormControlName).reset();
        if (this.showVerifyApplicationOptions) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(previousReferenceNumber);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
        }
        else {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        }
        this.createApplicationService.propertyData = null;
        this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).get(this.notesFormFormArrayName).clear();
        this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).reset();
    }
    onVerifyReferenceNumberClicked() {
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        if (previousReferenceNumber != null || previousReferenceNumber !== "") {
            const params = {
                previousReferenceNumber,
                isResubmission: this.showVerifyApplicationOptions,
                moduleId: this.appController.selectedModuleID
            };
            this.wayleaveService.verifyResubmissionReferenceNumberObservable(params).subscribe({
                next: value => {
                    this.showApplicationDetailsFields = true;
                    this.aflaModuleStrategyService.previousApplication = value;
                    this.onGetApplicationDetailsCompleted(value);
                    this.getCompleteApplication();
                    this.appController.showMessage(this.verificationMessage, AlertType.Success);
                    this.isVerified = true;
                },
                error: err => {
                    this.appController.showMessage(err.error, AlertType.Error);
                    this.showApplicationDetailsFields = false;
                    this.isVerified = false;
                }
            });
            this.changeDetectorRefs.detectChanges();
        }
    }
    onGetApplicationDetailsCompleted(response) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(response.description);
        this.detailsForm.get(this.clientReferenceNumberFormControlName).setValue(response.clientReferenceNumber);
        this.detailsForm.get(this.applicantTelecommunicationLicenseNumberFormControlName).setValue(response.licenceNumber);
        this.detailsForm.get(this.scopeOfWorkFormControlName).setValue(response.scopeOfWork);
        this.detailsForm.get(this.estimatedConstructionCostFormControlName).setValue(response.estimatedCost);
        this.detailsForm.get(this.applicationFeeFormControlName).setValue(response.applicationFee);
        this.detailsForm.get(this.constructionPeriodFormControlName).setValue(response.constructionPeriod);
        this.detailsForm.get(this.proposedStartDateFormControlName).setValue(this.datePipe.transform(response.proposedStartDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.proposedEndDateFormControlName).setValue(this.datePipe.transform(response.proposedEndDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.laneClosureIsRequiredFormControlName).setValue(response.laneClosureRequired);
        this.detailsForm.get(this.actualStartDateFormControlName).setValue(response.actualStartDate);
        this.detailsForm.get(this.actualEndDateFormControlName).setValue(response.actualEndDate);
        this.detailsForm.get(this.clientReferenceNumberFormControlName).setValue(response.referenceNumber);
        this.laneClosureExtentOptions.forEach(item => {
            if (item.value === response.laneClosureExtent) {
                this.detailsForm.get(this.laneClosureExtentFormControlName).setValue(item.value);
            }
        });
        this.electricalServicesOptions.forEach(item => {
            if (item.value === response.electricalServices) {
                this.detailsForm.get(this.electricalServicesFormControlName).setValue(item.value);
            }
        });
        this.constructionPeriodUnitsOptions.forEach(item => {
            if (item.value === response.constructionPeriodUnits) {
                this.detailsForm.get(this.constructionPeriodUnitsFormControlName).setValue(item.value);
            }
        });
        this.servicesOptions.forEach(item => {
            if (item.value === response.services) {
                this.detailsForm.get(this.servicesFormControlName).setValue(item.value);
            }
        });
        this.applicationTypeOptions.forEach(item => {
            if (item.value === response.applicationType) {
                this.detailsForm.get(this.applicationTypeFormControlName).setValue(item.value);
            }
        });
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    getCompleteApplication() {
        const params = {
            $filter: `jobId eq ${this.aflaModuleStrategyService.previousApplication.jobId} and moduleId eq ${this.appController.selectedModuleID}`,
            $expand: `applicationLines, applicationPolygons, contractor($expand=groups), implementingAgent($expand=groups), engineer($expand=groups), applicant($expand=groups),applicantAgent($expand=groups), applicantAgent($expand=groups), notes`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const application = this.cleanPreviousApplicationData(returnValue.value[0]);
            this.aflaModuleStrategyService.previousApplication = application;
            // set applicant form data
            if (application.applicant[0] != null) {
                this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).get(this.applicantFormControlName).setValue(application.applicant[0]);
            }
            // set applicant Agent form data
            if (application.applicantAgent[0] != null) {
                this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).get(this.applicantAgentFormControlName).setValue(application.applicantAgent[0]);
            }
            // set implementingAgent
            if (application.implementingAgent[0] != null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.implementingAgentFormControlName).setValue(application.implementingAgent[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markImplementingAgentAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.implementingAgentFormControlName).enable();
            }
            // set engineer
            if (application.engineer[0] != null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.engineerFormControlName).setValue(application.engineer[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markEngineerAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.engineerFormControlName).enable();
            }
            // set contractor
            if (application.contractor[0] != null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.responsibleContractorFormControlName).setValue(application.contractor[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markContractorAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.responsibleContractorFormControlName).enable();
            }
            if (application.applicationLines && application.applicationLines.length > 0) {
                this.createApplicationService.applicationData = application;
                const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.shape, 102100);
                const centroid = JsonUtils.fromJSON(centroidGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).get("centroid").setValue(centroid);
                const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationLines[0].shape, 102100);
                const polyline = JsonUtils.fromJSON(polylineGeometryArc);
                this.aflaModuleStrategyService.form.get("polyline").setValue(polyline);
                this.aflaModuleStrategyService.form.get("polylineDto").setValue(application.applicationLines[0]);
            }
            if (application.applicationPolygons && application.applicationPolygons.length > 0) {
                this.createApplicationService.applicationData = application;
                const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.shape, 102100);
                const centroid = JsonUtils.fromJSON(centroidGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).get("centroid").setValue(centroid);
                const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationPolygons[0].shape, 102100);
                const polygon = JsonUtils.fromJSON(polygonGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).get("polygon").setValue(polygon);
                this.aflaModuleStrategyService.form.get(this.locationFormFormGroupName).get("polygonDto").setValue(application.applicationPolygons[0]);
            }
            // set notes
            if (application.notes && application.notes.length > 0) {
                this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).get(this.notesFormFormArrayName).clear();
                this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).reset();
                application.notes.forEach((noteItem) => {
                    this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).get(this.notesFormFormArrayName).push(new FormGroup({
                        note: new FormControl(noteItem.note),
                    }));
                });
            }
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.createdUser = application.createdUser;
            app.createdUserId = application.createdUserId;
            app.createdDate = application.createdDate;
            app.startDate = application.startDate;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.description = application.description;
            app.applicationType = application.applicationType;
            app.moduleId = application.moduleId;
            app.deleted = application.deleted;
            app.lastEditedBy = application.lastEditedBy;
            app.lastEditedDate = application.lastEditedDate;
            app.applicantId = application.applicantId;
            app.applicantAgentId = application.applicantAgentId;
            app.implementingAgentId = application.implementingAgentId;
            app.engineerId = application.engineerId;
            app.contractorId = application.contractorId;
            app.clientReferenceNumber = application.clientReferenceNumber;
            app.estimatedCost = application.estimatedCost;
            app.licenceNumber = application.licenceNumber;
            app.scopeOfWork = application.scopeOfWork;
            app.estimatedCost = application.estimatedCost;
            app.constructionPeriod = application.constructionPeriod;
            app.constructionPeriodUnits = application.constructionPeriodUnits;
            app.services = application.services;
            app.electricalServices = application.electricalServices;
            app.applicationFee = application.applicationFee;
            app.proposedStartDate = application.proposedStartDate;
            app.proposedEndDate = application.proposedEndDate;
            app.actualStartDate = application.actualStartDate;
            app.actualEndDate = application.actualEndDate;
            app.laneClosureRequired = application.laneClosureRequired;
            app.laneClosureExtent = application.laneClosureExtent;
            app.status = application.status;
            app.notes = application.notes;
            app.assessments = application.assessments;
            app.communications = application.communications;
            app.conditions = application.conditions;
            app.invoices = application.invoices;
            app.results = application.results;
            app.createdSystemUser = application.createdSystemUser;
            app.applicant = application.applicant;
            app.applicantAgent = application.applicantAgent;
            app.implementingAgent = application.implementingAgent;
            app.engineer = application.engineer;
            app.contractor = application.contractor;
            app.attachments = application.attachments;
            app.auditActions = application.auditActions;
            app.workflowSection = application.workflowSection;
            app.daysUntilExpired = application.daysUntilExpired;
            app.lastEditedUser = application.lastEditedUser;
            app.applicationLines = application.applicationLines;
            app.applicationPolygons = application.applicationPolygons;
            app.applicantAgentNa = application.applicantAgentNa;
            app.contractorNa = application.contractorNa;
            app.engineerNa = application.engineerNa;
            app.implementingAgentNa = application.implementingAgentNa;
        }
        if (application.applicationLines && application.applicationLines.length > 0) {
            const applicationLines = [];
            application.applicationLines.forEach(p => {
                const applicationLine = {};
                applicationLine.id = p.id;
                applicationLine.shape = p.shape;
                applicationLine.wkid = p.wkid;
                applicationLine.applicationId = p.applicationId;
                applicationLine.deleted = false;
                applicationLine.jobId = p.jobId;
                applicationLines.push(applicationLine);
            });
            app.applicationLines = applicationLines;
        }
        if (application.applicationPolygons && application.applicationPolygons.length > 0) {
            const applicationPolygons = [];
            application.applicationPolygons.forEach(p => {
                const applicationPolygon = {};
                applicationPolygon.id = p.id;
                applicationPolygon.shape = p.shape;
                applicationPolygon.wkid = p.wkid;
                applicationPolygon.applicationId = p.applicationId;
                applicationPolygon.deleted = false;
                applicationPolygon.jobId = p.jobId;
                applicationPolygons.push(applicationPolygon);
            });
            app.applicationPolygons = applicationPolygons;
        }
        if (application.applicant && application.applicant.length > 0) {
            const applicants = [];
            application.applicant.forEach(a => {
                const applicant = {};
                applicant.clientVatNumber = a.clientVatNumber;
                applicant.setRecipient = a.setRecipient;
                applicant.fullName = a.fullName;
                applicant.id = 0;
                applicant.moduleId = a.moduleId;
                applicant.name = a.name;
                applicant.surname = a.surname;
                applicant.telephone = a.telephone;
                applicant.email = a.email;
                applicant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicant.postalAddress = a.postalAddress;
                applicant.designation = a.designation;
                applicant.organisation = a.organisation;
                applicant.streetAddress = a.streetAddress;
                applicant.homePhone = a.homePhone;
                applicant.idNumber = a.idNumber;
                applicant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicant.representative = a.representative;
                applicant.fax = a.fax;
                applicant.maritalStatus = a.maritalStatus;
                applicant.relativesFullName = a.relativesFullName;
                applicant.relativesContactNumber = a.relativesContactNumber;
                applicant.relativesAddress = a.relativesAddress;
                applicant.employmentStatus = a.employmentStatus;
                applicant.employersName = a.employersName;
                applicant.employersContactNumber = a.employersContactNumber;
                applicant.employersAddress = a.employersAddress;
                applicant.cellphone = a.cellphone;
                applicant.streetSuburb = a.streetSuburb;
                applicant.streetCity = a.streetCity;
                applicant.streetProvince = a.streetProvince;
                applicant.streetCode = a.streetCode;
                applicant.postalSuburb = a.postalSuburb;
                applicant.postalCity = a.postalCity;
                applicant.postalProvince = a.postalProvince;
                applicant.postalCode = a.postalCode;
                applicant.postalCountry = a.postalCountry;
                applicant.streetCountry = a.streetCountry;
                applicant.professionalBody = a.professionalBody;
                applicant.professionalBodyRegNum = a.professionalBodyRegNum;
                applicant.consolidatedGroup = a.consolidatedGroup;
                applicant.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicant.groups = groups;
                applicants.push(applicant);
            });
            app.applicant = applicants;
        }
        if (application.applicantAgent && application.applicantAgent.length > 0) {
            const applicantAgents = [];
            application.applicantAgent.forEach(a => {
                const applicantAgent = {};
                applicantAgent.clientVatNumber = a.clientVatNumber;
                applicantAgent.setRecipient = a.setRecipient;
                applicantAgent.fullName = a.fullName;
                applicantAgent.id = 0;
                applicantAgent.moduleId = a.moduleId;
                applicantAgent.name = a.name;
                applicantAgent.surname = a.surname;
                applicantAgent.telephone = a.telephone;
                applicantAgent.email = a.email;
                applicantAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicantAgent.postalAddress = a.postalAddress;
                applicantAgent.designation = a.designation;
                applicantAgent.organisation = a.organisation;
                applicantAgent.streetAddress = a.streetAddress;
                applicantAgent.homePhone = a.homePhone;
                applicantAgent.idNumber = a.idNumber;
                applicantAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicantAgent.representative = a.representative;
                applicantAgent.fax = a.fax;
                applicantAgent.maritalStatus = a.maritalStatus;
                applicantAgent.relativesFullName = a.relativesFullName;
                applicantAgent.relativesContactNumber = a.relativesContactNumber;
                applicantAgent.relativesAddress = a.relativesAddress;
                applicantAgent.employmentStatus = a.employmentStatus;
                applicantAgent.employersName = a.employersName;
                applicantAgent.employersContactNumber = a.employersContactNumber;
                applicantAgent.employersAddress = a.employersAddress;
                applicantAgent.cellphone = a.cellphone;
                applicantAgent.streetSuburb = a.streetSuburb;
                applicantAgent.streetCity = a.streetCity;
                applicantAgent.streetProvince = a.streetProvince;
                applicantAgent.streetCode = a.streetCode;
                applicantAgent.postalSuburb = a.postalSuburb;
                applicantAgent.postalCity = a.postalCity;
                applicantAgent.postalProvince = a.postalProvince;
                applicantAgent.postalCode = a.postalCode;
                applicantAgent.postalCountry = a.postalCountry;
                applicantAgent.streetCountry = a.streetCountry;
                applicantAgent.professionalBody = a.professionalBody;
                applicantAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                applicantAgent.consolidatedGroup = a.consolidatedGroup;
                applicantAgent.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicantAgent.groups = groups;
                applicantAgents.push(applicantAgent);
            });
            app.applicantAgent = applicantAgents;
        }
        if (application.implementingAgent && application.implementingAgent.length > 0) {
            const implementingAgents = [];
            application.implementingAgent.forEach(a => {
                const implementingAgent = {};
                implementingAgent.clientVatNumber = a.clientVatNumber;
                implementingAgent.setRecipient = a.setRecipient;
                implementingAgent.fullName = a.fullName;
                implementingAgent.id = 0;
                implementingAgent.moduleId = a.moduleId;
                implementingAgent.name = a.name;
                implementingAgent.surname = a.surname;
                implementingAgent.telephone = a.telephone;
                implementingAgent.email = a.email;
                implementingAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                implementingAgent.postalAddress = a.postalAddress;
                implementingAgent.designation = a.designation;
                implementingAgent.organisation = a.organisation;
                implementingAgent.streetAddress = a.streetAddress;
                implementingAgent.homePhone = a.homePhone;
                implementingAgent.idNumber = a.idNumber;
                implementingAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                implementingAgent.representative = a.representative;
                implementingAgent.fax = a.fax;
                implementingAgent.maritalStatus = a.maritalStatus;
                implementingAgent.relativesFullName = a.relativesFullName;
                implementingAgent.relativesContactNumber = a.relativesContactNumber;
                implementingAgent.relativesAddress = a.relativesAddress;
                implementingAgent.employmentStatus = a.employmentStatus;
                implementingAgent.employersName = a.employersName;
                implementingAgent.employersContactNumber = a.employersContactNumber;
                implementingAgent.employersAddress = a.employersAddress;
                implementingAgent.cellphone = a.cellphone;
                implementingAgent.streetSuburb = a.streetSuburb;
                implementingAgent.streetCity = a.streetCity;
                implementingAgent.streetProvince = a.streetProvince;
                implementingAgent.streetCode = a.streetCode;
                implementingAgent.postalSuburb = a.postalSuburb;
                implementingAgent.postalCity = a.postalCity;
                implementingAgent.postalProvince = a.postalProvince;
                implementingAgent.postalCode = a.postalCode;
                implementingAgent.postalCountry = a.postalCountry;
                implementingAgent.streetCountry = a.streetCountry;
                implementingAgent.professionalBody = a.professionalBody;
                implementingAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                implementingAgent.consolidatedGroup = a.consolidatedGroup;
                implementingAgent.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                implementingAgent.groups = groups;
                implementingAgents.push(implementingAgent);
            });
            app.implementingAgent = implementingAgents;
        }
        if (application.engineer && application.engineer.length > 0) {
            let engineers = {};
            engineers = [];
            application.engineer.forEach(a => {
                const engineer = {};
                engineer.clientVatNumber = a.clientVatNumber;
                engineer.setRecipient = a.setRecipient;
                engineer.fullName = a.fullName;
                engineer.id = 0;
                engineer.moduleId = a.moduleId;
                engineer.name = a.name;
                engineer.surname = a.surname;
                engineer.telephone = a.telephone;
                engineer.email = a.email;
                engineer.defaultCommunicationMethod = a.defaultCommunicationMethod;
                engineer.postalAddress = a.postalAddress;
                engineer.designation = a.designation;
                engineer.organisation = a.organisation;
                engineer.streetAddress = a.streetAddress;
                engineer.homePhone = a.homePhone;
                engineer.idNumber = a.idNumber;
                engineer.organisationRegistrationNumber = a.organisationRegistrationNumber;
                engineer.representative = a.representative;
                engineer.fax = a.fax;
                engineer.maritalStatus = a.maritalStatus;
                engineer.relativesFullName = a.relativesFullName;
                engineer.relativesContactNumber = a.relativesContactNumber;
                engineer.relativesAddress = a.relativesAddress;
                engineer.employmentStatus = a.employmentStatus;
                engineer.employersName = a.employersName;
                engineer.employersContactNumber = a.employersContactNumber;
                engineer.employersAddress = a.employersAddress;
                engineer.cellphone = a.cellphone;
                engineer.streetSuburb = a.streetSuburb;
                engineer.streetCity = a.streetCity;
                engineer.streetProvince = a.streetProvince;
                engineer.streetCode = a.streetCode;
                engineer.postalSuburb = a.postalSuburb;
                engineer.postalCity = a.postalCity;
                engineer.postalProvince = a.postalProvince;
                engineer.postalCode = a.postalCode;
                engineer.postalCountry = a.postalCountry;
                engineer.streetCountry = a.streetCountry;
                engineer.professionalBody = a.professionalBody;
                engineer.professionalBodyRegNum = a.professionalBodyRegNum;
                engineer.consolidatedGroup = a.consolidatedGroup;
                engineer.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                engineer.groups = groups;
                engineers.push(engineer);
            });
            app.engineer = engineers;
        }
        if (application.contractor && application.contractor.length > 0) {
            const contractors = [];
            application.contractor.forEach(a => {
                const contractor = {};
                contractor.clientVatNumber = a.clientVatNumber;
                contractor.setRecipient = a.setRecipient;
                contractor.fullName = a.fullName;
                contractor.id = 0;
                contractor.moduleId = a.moduleId;
                contractor.name = a.name;
                contractor.surname = a.surname;
                contractor.telephone = a.telephone;
                contractor.email = a.email;
                contractor.defaultCommunicationMethod = a.defaultCommunicationMethod;
                contractor.postalAddress = a.postalAddress;
                contractor.designation = a.designation;
                contractor.organisation = a.organisation;
                contractor.streetAddress = a.streetAddress;
                contractor.homePhone = a.homePhone;
                contractor.idNumber = a.idNumber;
                contractor.organisationRegistrationNumber = a.organisationRegistrationNumber;
                contractor.representative = a.representative;
                contractor.fax = a.fax;
                contractor.maritalStatus = a.maritalStatus;
                contractor.relativesFullName = a.relativesFullName;
                contractor.relativesContactNumber = a.relativesContactNumber;
                contractor.relativesAddress = a.relativesAddress;
                contractor.employmentStatus = a.employmentStatus;
                contractor.employersName = a.employersName;
                contractor.employersContactNumber = a.employersContactNumber;
                contractor.employersAddress = a.employersAddress;
                contractor.cellphone = a.cellphone;
                contractor.streetSuburb = a.streetSuburb;
                contractor.streetCity = a.streetCity;
                contractor.streetProvince = a.streetProvince;
                contractor.streetCode = a.streetCode;
                contractor.postalSuburb = a.postalSuburb;
                contractor.postalCity = a.postalCity;
                contractor.postalProvince = a.postalProvince;
                contractor.postalCode = a.postalCode;
                contractor.postalCountry = a.postalCountry;
                contractor.streetCountry = a.streetCountry;
                contractor.professionalBody = a.professionalBody;
                contractor.professionalBodyRegNum = a.professionalBodyRegNum;
                contractor.consolidatedGroup = a.consolidatedGroup;
                contractor.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                contractor.groups = groups;
                contractors.push(contractor);
            });
            app.contractor = contractors;
        }
        return app;
    }
    checkIsResubmission() {
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
            this.showApplicationDetailsFields = false;
        }
        else {
            this.showApplicationDetailsFields = true;
        }
    }
    checkLookups() {
        if (this.aflaModuleStrategyService.lookups.has("laneClosureExtents") &&
            this.aflaModuleStrategyService.lookups.has("applicationType") &&
            this.aflaModuleStrategyService.lookups.has("services") &&
            this.aflaModuleStrategyService.lookups.has("electricalServices")) {
            this.laneClosureExtentOptions = this.aflaModuleStrategyService.lookups.get("laneClosureExtents");
            this.applicationTypeOptions = this.aflaModuleStrategyService.lookups.get("applicationType");
            this.servicesOptions = this.aflaModuleStrategyService.lookups.get("services");
            this.electricalServicesOptions = this.aflaModuleStrategyService.lookups.get("electricalServices");
            this.yesNoOptions = [];
            this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        }
        else {
            this.getLookups();
        }
    }
    onSimulateMode() {
        const defaults = SimulationUtils.simulate_Create_Application();
        this.laneClosureExtentOptions = defaults.laneClosureExtentOptions;
        this.electricalServicesOptions = defaults.laneClosureExtentOptions;
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
    }
    repopulateDetailsPage() {
        const isModuleResubmissionEnabled = this.appController.moduleAllowResubmission;
        const isResubmissionValue = this.detailsForm.get(this.isResubmissionFormControlName).value;
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        const descriptionValue = this.detailsForm.get(this.descriptionFormControlName).value;
        const scopeValue = this.detailsForm.get(this.scopeOfWorkFormControlName).value;
        if (isModuleResubmissionEnabled) {
            this.supportResubmissions = true;
            if (isResubmissionValue === "Yes") {
                this.showVerifyApplicationOptions = true;
                if (previousReferenceNumber && descriptionValue && scopeValue) {
                    this.showApplicationDetailsFields = true;
                }
                else {
                    this.showApplicationDetailsFields = false;
                }
            }
            if (isResubmissionValue === "No") {
                this.showVerifyApplicationOptions = false;
                this.showApplicationDetailsFields = true;
            }
            if (isResubmissionValue === null) {
                this.showApplicationDetailsFields = false;
            }
        }
        else {
            this.supportResubmissions = false;
            this.showApplicationDetailsFields = true;
        }
        this.changeDetectorRefs.detectChanges();
    }
    setRequiredFieldsFromStepMeta(applicationDetailsFields) {
        for (const [formControlName, applicationDetailsFieldsOptions] of Object.entries(applicationDetailsFields)) {
            if (applicationDetailsFieldsOptions.required) {
                this.detailsForm.get(`${formControlName}`).addValidators(Validators.required);
                this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            }
            if (applicationDetailsFieldsOptions.required === false) {
                this.detailsForm.get(`${formControlName}`).clearValidators();
                this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            }
            this.detailsForm.updateValueAndValidity();
        }
    }
    showOrHideApplicationDetailsFields(applicationDetailsFields) {
        for (const [formControlName, applicationDetailsFieldsOptions] of Object.entries(applicationDetailsFields)) {
            const control = this.detailsForm.get(formControlName);
            if (!control)
                return;
            const fieldsOptions = applicationDetailsFieldsOptions;
            if (!fieldsOptions)
                return;
            this.detailsForm.get(`${formControlName}`).clearValidators();
            this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            this[`show${formControlName}`] = applicationDetailsFieldsOptions.visible;
            this.detailsForm.updateValueAndValidity();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: WayleaveService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsWComponent = __decorate([
    Component({
        selector: "app-create-application-details-w",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsWComponent);
export { CreateApplicationDetailsWComponent };
